<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-card>
                <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                    <v-flex lg4 md4 sm12>
                        <h-currency-input v-model="currentItem.exchange_rate" label="Tỷ giá CNY" :decimal="0" class="input-group--focused"></h-currency-input>
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                        <h-currency-input v-model="currentItem.weight_price" label="Giá cân" :decimal="0" class="input-group--focused"></h-currency-input>
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-container>
    </div>
    </template>
    
    <script>
    import {
        mapState
    } from "vuex";
    
    export default {
        computed: {
            ...mapState({
                loading: state => state.configurations.loading,
                currentItem: state => state.configurations.selected
            })
        },
        methods: {
            refreshData() {
                this.$store.dispatch("configurations/getDetail", 1);
            },
            saveData() {
                this.$store.dispatch("configurations/setDetail", {
                    data: this.currentItem,
                    id: this.currentItem.id
                });
            },
        },
        mounted() {
            this.refreshData();
            this.$root.$emit('REQUEST_ROOT_OPTION', {});
            this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
        },
    };
    </script>